/* eslint-disable */
import * as Types from '../graphqlTypes';

import { gql } from '@apollo/client';
import { AttachmentSnapshotFragmentDoc } from '../features/attachments/Attachments.generated';
import { AddressDetails__AddressFragmentDoc } from '../features/addresses/Addresses.generated';
export type WithCompanyInfo_Company_Fragment = { __typename: 'Company', id: string, title: string, description: string, website: string, isMeister: boolean, contactPerson?: { __typename: 'Person', id: string, title: Types.Salutation, description: string, website?: string | null, isMeister: boolean, familyname: string, firstname: string, fullname: string, locale: string, skillset: Array<Types.Skill> } | null };

export type WithCompanyInfo_CrmCompany_Fragment = { __typename: 'CrmCompany', id: string, title: string, description: string, website: string, isMeister: boolean, contactPerson?: { __typename: 'CrmPerson', id: string, title: Types.Salutation, description: string, website?: string | null, isMeister: boolean, familyname: string, firstname: string, fullname: string, locale: string, skillset: Array<Types.Skill> } | null };

export type WithCompanyInfo_Organisation_Fragment = { __typename: 'Organisation', id: string, title: string, description: string, website: string, isMeister: boolean, contactPerson?: { __typename: 'Person', id: string, title: Types.Salutation, description: string, website?: string | null, isMeister: boolean, familyname: string, firstname: string, fullname: string, locale: string, skillset: Array<Types.Skill> } | null };

export type WithCompanyInfo_ViewerOrganisation_Fragment = { __typename: 'ViewerOrganisation', id: string, title: string, description: string, website: string, isMeister: boolean, contactPerson?: { __typename: 'Person', id: string, title: Types.Salutation, description: string, website?: string | null, isMeister: boolean, familyname: string, firstname: string, fullname: string, locale: string, skillset: Array<Types.Skill> } | null };

export type WithCompanyInfoFragment = WithCompanyInfo_Company_Fragment | WithCompanyInfo_CrmCompany_Fragment | WithCompanyInfo_Organisation_Fragment | WithCompanyInfo_ViewerOrganisation_Fragment;

export type WithContactInfo_Company_Fragment = { __typename: 'Company', id: string, email: any, phones: Array<{ __typename: 'Phone', id: string, main: boolean, type: Types.PhoneType, number: string }> };

export type WithContactInfo_CrmCompany_Fragment = { __typename: 'CrmCompany', id: string, email: any, phones: Array<{ __typename: 'Phone', id: string, main: boolean, type: Types.PhoneType, number: string }> };

export type WithContactInfo_CrmPerson_Fragment = { __typename: 'CrmPerson', id: string, email: any, phones: Array<{ __typename: 'Phone', id: string, main: boolean, type: Types.PhoneType, number: string }> };

export type WithContactInfo_Organisation_Fragment = { __typename: 'Organisation', id: string, email: any, phones: Array<{ __typename: 'Phone', id: string, main: boolean, type: Types.PhoneType, number: string }> };

export type WithContactInfo_Person_Fragment = { __typename: 'Person', id: string, email: any, phones: Array<{ __typename: 'Phone', id: string, main: boolean, type: Types.PhoneType, number: string }> };

export type WithContactInfo_User_Fragment = { __typename: 'User', id: string, email: any, phones: Array<{ __typename: 'Phone', id: string, main: boolean, type: Types.PhoneType, number: string }> };

export type WithContactInfo_Viewer_Fragment = { __typename: 'Viewer', id: string, email: any, phones: Array<{ __typename: 'Phone', id: string, main: boolean, type: Types.PhoneType, number: string }> };

export type WithContactInfo_ViewerOrganisation_Fragment = { __typename: 'ViewerOrganisation', id: string, email: any, phones: Array<{ __typename: 'Phone', id: string, main: boolean, type: Types.PhoneType, number: string }> };

export type WithContactInfoFragment = WithContactInfo_Company_Fragment | WithContactInfo_CrmCompany_Fragment | WithContactInfo_CrmPerson_Fragment | WithContactInfo_Organisation_Fragment | WithContactInfo_Person_Fragment | WithContactInfo_User_Fragment | WithContactInfo_Viewer_Fragment | WithContactInfo_ViewerOrganisation_Fragment;

export type WithLogo_Company_Fragment = { __typename: 'Company', id: string, title: string, logo: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } };

export type WithLogo_CrmCompaniesRecord_Fragment = { __typename: 'CrmCompaniesRecord', id: string, title: string, logo: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } };

export type WithLogo_CrmCompany_Fragment = { __typename: 'CrmCompany', id: string, title: string, logo: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } };

export type WithLogo_Organisation_Fragment = { __typename: 'Organisation', id: string, title: string, logo: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } };

export type WithLogo_ReceivedLinkingInvitation_Fragment = { __typename: 'ReceivedLinkingInvitation', id: string, title: string, logo: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } };

export type WithLogo_ReferralInfo_Fragment = { __typename: 'ReferralInfo', id: string, title: string, logo: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } };

export type WithLogo_ViewerOrganisation_Fragment = { __typename: 'ViewerOrganisation', id: string, title: string, logo: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } };

export type WithLogoFragment = WithLogo_Company_Fragment | WithLogo_CrmCompaniesRecord_Fragment | WithLogo_CrmCompany_Fragment | WithLogo_Organisation_Fragment | WithLogo_ReceivedLinkingInvitation_Fragment | WithLogo_ReferralInfo_Fragment | WithLogo_ViewerOrganisation_Fragment;

export type WithPersonInfo_CrmPerson_Fragment = { __typename: 'CrmPerson', id: string, title: Types.Salutation, description: string, website?: string | null, isMeister: boolean, familyname: string, firstname: string, fullname: string, locale: string, skillset: Array<Types.Skill> };

export type WithPersonInfo_Person_Fragment = { __typename: 'Person', id: string, title: Types.Salutation, description: string, website?: string | null, isMeister: boolean, familyname: string, firstname: string, fullname: string, locale: string, skillset: Array<Types.Skill> };

export type WithPersonInfo_User_Fragment = { __typename: 'User', id: string, title: Types.Salutation, description: string, website?: string | null, isMeister: boolean, familyname: string, firstname: string, fullname: string, locale: string, skillset: Array<Types.Skill> };

export type WithPersonInfo_Viewer_Fragment = { __typename: 'Viewer', id: string, title: Types.Salutation, description: string, website?: string | null, isMeister: boolean, familyname: string, firstname: string, fullname: string, locale: string, skillset: Array<Types.Skill> };

export type WithPersonInfoFragment = WithPersonInfo_CrmPerson_Fragment | WithPersonInfo_Person_Fragment | WithPersonInfo_User_Fragment | WithPersonInfo_Viewer_Fragment;

export type WithAvatar_CrmPerson_Fragment = { __typename: 'CrmPerson', id: string, fullname: string, firstname: string, familyname: string, avatar: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } };

export type WithAvatar_Person_Fragment = { __typename: 'Person', id: string, fullname: string, firstname: string, familyname: string, avatar: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } };

export type WithAvatar_User_Fragment = { __typename: 'User', id: string, fullname: string, firstname: string, familyname: string, avatar: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } };

export type WithAvatar_Viewer_Fragment = { __typename: 'Viewer', id: string, fullname: string, firstname: string, familyname: string, avatar: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } };

export type WithAvatarFragment = WithAvatar_CrmPerson_Fragment | WithAvatar_Person_Fragment | WithAvatar_User_Fragment | WithAvatar_Viewer_Fragment;

export type ViewerDetailsFragment = { __typename: 'Viewer', id: string, title: Types.Salutation, description: string, website?: string | null, isMeister: boolean, familyname: string, firstname: string, fullname: string, locale: string, skillset: Array<Types.Skill>, email: any, phones: Array<{ __typename: 'Phone', id: string, main: boolean, type: Types.PhoneType, number: string }>, avatar: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } };

export type UserDetailsFragment = { __typename: 'User', id: string, active: boolean, organisationId: string, organisationTitle: string, jobTitle: string, title: Types.Salutation, description: string, website?: string | null, isMeister: boolean, familyname: string, firstname: string, fullname: string, locale: string, skillset: Array<Types.Skill>, email: any, roles: Array<{ __typename: 'OrganisationRole', id: string, internalName: string, label: string }>, defaultProjectRoles: Array<{ __typename: 'ProjectRole', id: string, internalName: string, label: string }>, homeAddress?: { __typename: 'Address', id: string, streetLines1: string, city: string, postalCode: string, countryCode: string, lat: number, lng: number } | null, phones: Array<{ __typename: 'Phone', id: string, main: boolean, type: Types.PhoneType, number: string }>, avatar: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } };

export type InvitationContactFragment = { __typename: 'InvitationContact', id: string, title: Types.Salutation, company: string, firstname: string, familyname: string, email: any, logo: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } };

export const WithPersonInfoFragmentDoc = gql`
    fragment WithPersonInfo on WithPersonInfo {
  id
  title
  description
  website
  isMeister
  familyname
  firstname
  fullname
  locale
  skillset
}
    `;
export const WithCompanyInfoFragmentDoc = gql`
    fragment WithCompanyInfo on WithCompanyInfo {
  id
  title
  description
  website
  isMeister
  contactPerson {
    id
    ...WithPersonInfo
  }
}
    ${WithPersonInfoFragmentDoc}`;
export const WithLogoFragmentDoc = gql`
    fragment WithLogo on WithLogo {
  id
  logo {
    ...AttachmentSnapshot
  }
  title
}
    ${AttachmentSnapshotFragmentDoc}`;
export const WithContactInfoFragmentDoc = gql`
    fragment WithContactInfo on WithContactInfo {
  id
  email
  phones {
    id
    main
    type
    number
  }
}
    `;
export const WithAvatarFragmentDoc = gql`
    fragment WithAvatar on WithAvatar {
  id
  avatar {
    ...AttachmentSnapshot
  }
  fullname
  firstname
  familyname
}
    ${AttachmentSnapshotFragmentDoc}`;
export const ViewerDetailsFragmentDoc = gql`
    fragment ViewerDetails on Viewer {
  id
  ...WithPersonInfo
  ...WithContactInfo
  ...WithAvatar
}
    ${WithPersonInfoFragmentDoc}
${WithContactInfoFragmentDoc}
${WithAvatarFragmentDoc}`;
export const UserDetailsFragmentDoc = gql`
    fragment UserDetails on User {
  id
  ...WithPersonInfo
  ...WithContactInfo
  ...WithAvatar
  active
  roles {
    id
    internalName
    label
  }
  defaultProjectRoles {
    id
    internalName
    label
  }
  organisationId
  organisationTitle
  active
  jobTitle
  homeAddress {
    ...AddressDetails__Address
  }
}
    ${WithPersonInfoFragmentDoc}
${WithContactInfoFragmentDoc}
${WithAvatarFragmentDoc}
${AddressDetails__AddressFragmentDoc}`;
export const InvitationContactFragmentDoc = gql`
    fragment InvitationContact on InvitationContact {
  id
  title
  company
  firstname
  familyname
  email
  logo {
    ...AttachmentSnapshot
  }
}
    ${AttachmentSnapshotFragmentDoc}`;